module.exports = __webpack_public_path__ + "img/foto6.0f772285.jpg";